<template>
  <div class='EnbBanner'>
    <div class="Default" v-if="!slides.length">
      Seu Banner
    </div>
    <vueper-slides
    v-if="show & slides.length"
    :autoplay="true"
    :fade="true"
    :arrows="false"
    :bullets="false"
    :fixed-height="true"
    >
      <vueper-slide
        v-for="(slide, i) in slides"
        :key="i"
        :image="api + slide.img"
        @click="push(slide.link)"
        >
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import api from '@/mixins/api'
export default {
  name: 'EnbBanner',
  components: { VueperSlides, VueperSlide },
  mixins: [api],
  data () {
    return {
      slides: [],
      show: false
    }
  },
  methods: {
    ...mapActions(['GetBannerImg']),
    push (link) {
      window.location.replace(link)
    }
  },
  created () {
    this.GetBannerImg()
      .then(res => {
        this.slides = res
        this.show = true
      })
  }
}
</script>

<style scoped>
.EnbBanner {
  width: 200px;
  height: 180px;
  margin: auto;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
}

.Default {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  border: thin solid #CCCCCC;
  border-radius: 12px;
}

.vueperslides--fixed-height { width: 200px; height: 180px; }
</style>
